import type { Template } from "@/types";

export const PO_06_H1_V5: Template[] = [
    {
        id: "po-06-h1v5-01",
        name: "PO 01 - H1V5",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h1_v5_01.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 73, y: 135, width: 504, height: 320, rotation: 0, imageRotation: 0 },
            { id: "2", x: 73, y: 463, width: 163, height: 228, rotation: 0, imageRotation: 0 },
            { id: "3", x: 244, y: 463, width: 163, height: 228, rotation: 0, imageRotation: 0 },
            { id: "4", x: 415, y: 463, width: 162, height: 228, rotation: 0, imageRotation: 0 },
            { id: "5", x: 710, y: 243, width: 260, height: 341, rotation: 0, imageRotation: 0 },
            { id: "6", x: 978, y: 243, width: 260, height: 341, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h1v5-02",
        name: "PO 02 - H1V5",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h1_v5_02.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 144, y: 156, width: 362, height: 515, rotation: 0, imageRotation: 0 },
            { id: "2", x: 696, y: 156, width: 178, height: 254, rotation: 0, imageRotation: 0 },
            { id: "3", x: 696, y: 418, width: 178, height: 253, rotation: 0, imageRotation: 0 },
            { id: "4", x: 882, y: 418, width: 178, height: 253, rotation: 0, imageRotation: 0 },          
            { id: "5", x: 882, y: 156, width: 364, height: 254, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1068, y: 418, width: 178, height: 253, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "hs-06-h1v5-03",
        name: "HS 03 - H1V5",
        albumType: "HS",
        thumbnail: "/thumbnails/PO/po-06-h1_v5_03.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 143, y: 156, width: 177, height: 263, rotation: 0, imageRotation: 0 },
            { id: "2", x: 328, y: 156, width: 177, height: 263, rotation: 0, imageRotation: 0 },
            { id: "3", x: 143, y: 427, width: 362, height: 245, rotation: 0, imageRotation: 0 },
            { id: "4", x: 697, y: 156, width: 364, height: 515, rotation: 0, imageRotation: 0 },     
            { id: "5", x: 1069, y: 156, width: 178, height: 254, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1069, y: 418, width: 178, height: 253, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h1v5-04",
        name: "PO 04 - H1V5",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h1_v5_04.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 69, y: 177, width: 506, height: 296, rotation: 0, imageRotation: 0 },           
            { id: "2", x: 69, y: 481, width: 121, height: 171, rotation: 0, imageRotation: 0 },
            { id: "3", x: 198, y: 481, width: 121, height: 171, rotation: 0, imageRotation: 0 },
            { id: "4", x: 327, y: 481, width: 120, height: 171, rotation: 0, imageRotation: 0 },
            { id: "5", x: 455, y: 481, width: 120, height: 171, rotation: 0, imageRotation: 0 },
            { id: "6", x: 806, y: 177, width: 335, height: 473, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h1v5-05",
        name: "PO 05 - H1V5",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h1_v5_05.png",
        size: [1298, 827],
        style: {},
        slots: [          
            { id: "1", x: 54, y: 214, width: 137, height: 196, rotation: 0, imageRotation: 0 },
            { id: "2", x: 54, y: 418, width: 137, height: 195, rotation: 0, imageRotation: 0 },
            { id: "3", x: 199, y: 214, width: 615, height: 399, rotation: 0, imageRotation: 0 },
            { id: "4", x: 822, y: 214, width: 276, height: 399, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1106, y: 214, width: 137, height: 196, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1106, y: 418, width: 137, height: 195, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h1v5-06",
        name: "PO 06 - H1V5",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h1_v5_06.png",
        size: [1298, 827],
        style: {},
        slots: [                   
            { id: "1", x: 54, y: 214, width: 137, height: 196, rotation: 0, imageRotation: 0 },
            { id: "2", x: 54, y: 418, width: 137, height: 195, rotation: 0, imageRotation: 0 },
            { id: "3", x: 199, y: 214, width: 616, height: 399, rotation: 0, imageRotation: 0 },
            { id: "4", x: 823, y: 214, width: 137, height: 196, rotation: 0, imageRotation: 0 },
            { id: "5", x: 823, y: 418, width: 137, height: 195, rotation: 0, imageRotation: 0 },
            { id: "6", x: 968, y: 214, width: 275, height: 399, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "po-06-h1v5-07",
        name: "PO 07 - H1V5",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h1_v5_07.png",
        size: [1298, 827],
        style: {},
        slots: [        
            { id: "1", x: 54, y: 214, width: 137, height: 196, rotation: 0, imageRotation: 0 },
            { id: "2", x: 54, y: 418, width: 137, height: 195, rotation: 0, imageRotation: 0 },
            { id: "3", x: 199, y: 214, width: 136, height: 196, rotation: 0, imageRotation: 0 },
            { id: "4", x: 199, y: 418, width: 136, height: 195, rotation: 0, imageRotation: 0 },
            { id: "5", x: 343, y: 214, width: 616, height: 399, rotation: 0, imageRotation: 0 },
            { id: "6", x: 967, y: 214, width: 275, height: 399, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h1v5-08",
        name: "PO 08 - H1V5",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h1_v5_08.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 0, y: 246, width: 223, height: 336, rotation: 0, imageRotation: 0 },
            { id: "2", x: 231, y: 246, width: 222, height: 336, rotation: 0, imageRotation: 0 },
            { id: "3", x: 461, y: 246, width: 489, height: 336, rotation: 0, imageRotation: 0 },
            { id: "4", x: 958, y: 246, width: 222, height: 336, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1188, y: 246, width: 110, height: 164, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1188, y: 418, width: 110, height: 164, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h1v5-09",
        name: "PO 09 - H1V5",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h1_v5_09.png",
        size: [1298, 827],
        style: {},
        slots: [         
            { id: "1", x: 39, y: 134, width: 193, height: 276, rotation: 0, imageRotation: 0 },
            { id: "2", x: 39, y: 418, width: 193, height: 276, rotation: 0, imageRotation: 0 },
            { id: "3", x: 240, y: 134, width: 882, height: 560, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1130, y: 134, width: 129, height: 182, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1130, y: 324, width: 129, height: 181, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1130, y: 513, width: 129, height: 181, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h1v5-10",
        name: "PO 10 - H1V5",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h1_v5_10.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 49, y: 158, width: 748, height: 511, rotation: 0, imageRotation: 0 },
            { id: "2", x: 805, y: 469, width: 143, height: 200, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1031, y: 158, width: 218, height: 303, rotation: 0, imageRotation: 0 },
            { id: "4", x: 805, y: 158, width: 218, height: 303, rotation: 0, imageRotation: 0 },
            { id: "5", x: 956, y: 469, width: 143, height: 200, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1107, y: 469, width: 142, height: 200, rotation: 0, imageRotation: 0 }

        ],
    }
];